import { FC } from "react"

import { ChatMessage } from "types/tournament.types"

interface ChatStatsProps {
  messages: ChatMessage[]
}

export const ChatStats: FC<ChatStatsProps> = ({ messages }) => {
  const reportedCount = messages.filter((m) => m.report_count > 0).length
  const deletedCount = messages.filter((m) => m.is_deleted).length
  const totalCount = messages.length

  return (
    <div className="mt-3 pt-3 border-t border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.1)] flex items-center justify-between text-xs text-gray-400 dark:text-gray-500">
      <span>Auto-refreshes every 5 seconds</span>
      <span>
        {reportedCount} reported · {deletedCount} deleted / {totalCount} total
      </span>
    </div>
  )
}
